"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CorrectLink = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const addFromParam = ({ href, linkFrom }) => {
    if (!linkFrom) {
        return href;
    }
    const [urlPath, urlQuery] = href.split('?');
    const params = new URLSearchParams(urlQuery);
    params.set('from', linkFrom);
    return urlPath + '?' + params.toString();
};
exports.CorrectLink = (_a) => {
    var { href, linkFrom, children } = _a, props = __rest(_a, ["href", "linkFrom", "children"]);
    if ((href === null || href === void 0 ? void 0 : href.startsWith('#')) || (href === null || href === void 0 ? void 0 : href.startsWith('http')) || (href === null || href === void 0 ? void 0 : href.match(/^(mailto:|tel:)/))) {
        const isInternalLink = (href === null || href === void 0 ? void 0 : href.startsWith('https://m2.ru')) || (href === null || href === void 0 ? void 0 : href.startsWith('https://test-m2.ru')) || (href === null || href === void 0 ? void 0 : href.startsWith('https://dev-m2.ru')) ||
            !(href === null || href === void 0 ? void 0 : href.startsWith('http'));
        return (react_1.default.createElement("a", Object.assign({ href: isInternalLink ? addFromParam({ href, linkFrom }) : href }, (!isInternalLink && { target: '_blank', rel: 'nofollow noreferrer noopener' }), props), children));
    }
    else if (href === null || href === void 0 ? void 0 : href.startsWith('/')) {
        return (react_1.default.createElement(react_router_dom_1.Link, Object.assign({ to: addFromParam({ href, linkFrom }) }, props), children));
    }
    else {
        return react_1.default.createElement("span", Object.assign({}, props), children);
    }
};
//# sourceMappingURL=correct-link.js.map